import { CTAS_PER_PAGE, MODELS_PER_PAGE } from '@utils/homeSearchConstants';
import React from 'react';

const numberOfModels = MODELS_PER_PAGE + CTAS_PER_PAGE;

export default function LoadingSkeleton(): JSX.Element {
  return (
    <div className="animate-pulse pb-96">
      <div className="mb-5 flex justify-between tablet:mb-[1.875rem]">
        <div className="h-8 w-20 rounded-md bg-gray-200"></div>
        <div className="h-8 w-44 rounded-md bg-gray-200"></div>
      </div>
      <div className="tablet:flex tablet:flex-wrap tablet:justify-between">
        {Array.from({ length: numberOfModels }).map((_, i) => (
          <LoadingCard key={i} />
        ))}
      </div>
    </div>
  );
}
function LoadingCard(): JSX.Element {
  return (
    // NOTE: This styling is kind of ugly, but it matches the original styles in the /find-a-home page content container.
    // So after content loads, the real photos align nicely with the loading skeleton.
    <div className="mb-[29px] space-y-1 tablet:w-[48%] min-[961px]:w-[31%]">
      <div className="aspect-[7/5] rounded-md bg-gray-200"></div>
      <div className="flex justify-between">
        <div className="flex-grow space-y-1">
          <div className="h-5 w-3/5 rounded-md bg-gray-200"></div>
          <div className="h-5 w-4/5 rounded-md bg-gray-200"></div>
        </div>
        <div className="flex flex-col items-end space-y-1">
          <div className="h-4 w-20 rounded-md bg-gray-200"></div>
          <div className="h-6 w-20 rounded-md bg-gray-200"></div>
        </div>
      </div>
    </div>
  );
}
